import React, { useEffect, useRef, useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { useDebounce } from "../../Components/useDebounce";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  formatDate,
  formatDateMonth,
  noDataFound,
  getCurrentFinancialYear,
} from "../../CommonMethhods/CommonMethods";
import {
  Client_Search,
  MFReports,
  MutualFund,
} from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import SmallLoader from "../../Components/Common/smallLoader";
import MFElssReportTable from "../../Components/ReportTables/MFElssReportTable";
import axiosInstance from "../../CommonMethhods/axiosInstance";

export default function ElssStatementReport() {
  const storeToken = localStorage.getItem("ssoToken");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const debouncedClientCode = useDebounce(clientCode, 1000);
  const [noNameFoundError, setNoNameFoundError] = useState("");
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState();
  const [offset, setOffset] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [yearError, setYearError] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
  const tableBodyRef = useRef(null);

  useEffect(() => {
    if (debouncedClientCode) {
      searchApiDetail(debouncedClientCode, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }, [debouncedClientCode]);
  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);
  const searchApiDetail = async (code, NoPage) => {
    const payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    const encPayload = AESEncryption(payloadValue);

    try {
      const response = await axiosInstance.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(response?.data);

      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNoNameFoundError("");
        setMainError("");
        setClientList((prev) =>
          page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
        );
      } else {
        setNoNameFoundError(res?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
    }
  };

  const handleScroll = async (e) => {
    const element = e.target;
    if (
      element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
      !scrollLoader
    ) {
      if (count > 10 * page) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const getElssReport = async (fileView, offsetTab) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }

    if (fileView === "grid" && offsetTab <= 1) {
      setLoader(true);
    }
    let payloadValue = {
      clientCode,
      fileType: fileView,
      pageNo: fileView === "grid" ? offsetTab : -1,
      pageSize: fileView === "grid" ? 10 : -1,
      fromDate,
      endDate: toDate,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(MFReports.ELSS, `"${encPayload}"`);

      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setDataCount(res?.data?.totalCount);
          if (offsetTab > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.elssStatement];
            });
          } else {
            setTableData(res?.data?.elssStatement);
          }
          setScrollLoaderTable(false);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setTableData([]);
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };

  const handleOnClick = (e) => {
    setOffset(1);
    setShow(false);
    if (e.target.value) {
      if (clientCode) {
        getElssReport(e.target.value, 1);
        setMainError(false);
        setYearError(false);
      } else {
        setMainError("Please Select Client Name/Code");
        setTableData([]);
      }
    } else {
      setMainError("Please Select Client Name/Code");
      setTableData([]);
    }
  };

  const handleTableScroll = (e) => {
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoaderTable) {
      const nextOffset = offset + 1;
      const totalLoadedRecords = offset * 10;

      if (dataCount > totalLoadedRecords && dataCount !== tableData.length) {
        setOffset(nextOffset); // This still updates state for future reference
        setScrollLoaderTable(true);
        setLoader(false);
        getElssReport("grid", nextOffset);
      } else {
        setScrollLoaderTable(false);
      }
    }
  };

  const currFYear = new Date().getFullYear();
  const lastFYear = currFYear - 1;
  const secondLastFYear = currFYear - 2;

  const changeFY = (e) => {
    const val = e.target.value;
    setSelectedYear(val);
    let date = new Date();
    let firstDay = "";
    let lastDay = "";

    if (val == "currYear") {
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear(),
        currentFyearStart.getMonth(),
        1
      );

      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "lastYear") {
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 1,
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 1,
        currentFyearEnd.getMonth(),
        31
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");

      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "secondLastYear") {
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 2,
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 2,
        currentFyearEnd.getMonth(),
        31
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else {
      setToDate("");
      setFromDate("");
    }
  };

  useEffect(() => {
    const el = tableBodyRef.current;

    if (!el) return;

    const checkScroll = () => {
      setHasVerticalScroll(el.scrollHeight > el.clientHeight);
    };

    checkScroll();

    const observer = new ResizeObserver(checkScroll);
    observer.observe(el);

    return () => observer.disconnect();
  }, [tableData]);

  return (
    <div>
      <div className="row input-field-wrapper">
        <div className="col-md-3 col-sm-3 col-6">
          <div className="form-group">
            <label className="form-label">
              Client Search<span className="text-danger">*</span>
            </label>
            <div className="rm-custom-dropdown">
              <input
                type="text"
                className="input-st"
                placeholder="Search here"
                autoComplete="off"
                value={clientCode}
                onChange={(e) => {
                  let value = e.target.value.toUpperCase();
                  value = value.replace(/[^A-Z0-9 ]/gi, "");
                  value = value.replace(/\s{2,}/g, " ");
                  value = value.replace(/^\s+/, "");

                  setClientCode(value);
                  setShow(true);
                }}
              />
              <button
                className="rm-dropdown-btn"
                onClick={() => setShow(!show)}
              >
                <span className="icon-right-arrow-triangle"></span>
              </button>
              {show && (
                <ul className="rm-mapping-ap border-0" onScroll={handleScroll}>
                  {clientList.map((item, i) => (
                    <li
                      key={i}
                      className="rm-maping-item-wrapper"
                      onClick={() => {
                        setClientCode(item?.clientCode);
                        setShow(false);
                      }}
                    >
                      <>
                        <div> {item?.clientname}</div>
                        <div> {item?.clientCode}</div>
                      </>
                    </li>
                  ))}
                  {scrollLoader && !loader && (
                    <div className="loader-center">
                      <LoaderForSearch />
                    </div>
                  )}
                  {noNameFoundError && !scrollLoader && (
                    <li
                      className="rm-maping-item-wrapper"
                      style={{ borderBottom: "none", fontSize: "12px" }}
                    >
                      {noNameFoundError}
                    </li>
                  )}
                </ul>
              )}
            </div>
            {mainError && (
              <span className="to-date-error main">{mainError}</span>
            )}
          </div>
        </div>

        <div className="col-md-3 col-sm-3 col-6">
          <div className="form-group">
            <label className="form-label">Select Financial Year</label>
            <select onChange={changeFY} style={{ height: "34px" }}>
              <option value="">Please Select</option>
              <option value="currYear">{"FY " + currFYear}</option>
              <option value="lastYear">{"FY " + lastFYear}</option>
              <option value="secondLastYear">{"FY " + secondLastFYear}</option>
            </select>
            {yearError && !selectedYear && (
              <span className="to-date-error main">{yearError}</span>
            )}
          </div>
        </div>

        <div className="text-center search-btn-wrapper mb-3 ">
          <button value="grid" className="send-message" onClick={handleOnClick}>
            {Constants.Search}
          </button>
        </div>
      </div>

      <div className="table-top-nav mr-4">
        <div className="table-dt-btn">
          <button
            value="excel"
            onClick={handleOnClick}
            className="generate-button excel-btn"
          >
            {" "}
            {smallLoaderExcel ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {"Excel"}
              </>
            )}
          </button>
        </div>
      </div>
      <div
        className={`mutualfund-table ${
          tableData?.length == 0 ? "nodatawrapper" : ""
        }`}
      >
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : tableData && tableData.length > 0 ? (
          <div className="scroll-table master_table mutualfundTab">
            {tableData && tableData?.length > 0 ? (
              <MFElssReportTable
                tableData={tableData}
                handleTableScroll={handleTableScroll}
                hasVerticalScroll={hasVerticalScroll}
                scrollLoaderTable={scrollLoaderTable}
                loader={loader}
                LoaderForSearch={LoaderForSearch}
                ref={tableBodyRef}
              />
            ) : (
              noDataFound()
            )}
          </div>
        ) : serverError ? (
          <h4 className="report-error-message">{noDataFound(serverError)}</h4>
        ) : errorGrid ? (
          noDataFound(errorGrid)
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
